<!--
 * @description:
 * @author: cuicui
 * @Date: 2023-01-19 23:52:51
 * @LastEditTime: 2025-09-11 16:17:59
 * @LastEditors: lwk liwkcool@163.com
-->
<template>
  <div class="admin-users">
    <page-title title="筛选">
      <el-row :gutter="20" class="admin-users__filter-header">
        <el-col :xl="3" :span="6">
          <span>作品名称：</span>
          <el-input v-model="filter.workName" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>注册手机号：</span>
          <el-input v-model="filter.phone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>工作站点：</span>
          <el-select clearable v-model="filter.workPlace" placeholder="请选择">
            <el-option
              v-for="s in workPlaceList"
              :label="s.place"
              :value="s.id"
              :key="s.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>登记来源：</span>
          <el-select
            clearable
            v-model="filter.registerSourceId"
            placeholder="请选择"
          >
            <el-option
              v-for="s in registerSourceList"
              :label="s.systemName"
              :value="s.id"
              :key="s.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>作品分类：</span>
          <el-select
            clearable
            v-model="filter.workCategory"
            placeholder="请选择"
          >
            <el-option
              v-for="s in workCategoryList"
              :label="s.category"
              :value="s.id"
              :key="s.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xl="10" :span="10">
          <span>登记时间区间：</span>
          <el-date-picker
            style="width: 100%"
            @change="handleFormatDate"
            v-model="value2"
            type="daterange"
            align="right"
            :default-time="['23:59:59', '00:00:00']"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="getList">查询</el-button>
          <el-button
            @click="
              filter = {};
              value2 = [];
              getList();
            "
            >重置</el-button
          >
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div style="margin-bottom: 20px">
        <el-radio-group
          v-model="filterStatus"
          size="small"
          @change="handleChange"
        >
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button v-for="s in STATUS" :label="s" :key="s">
            {{ STATUS_zh[s] }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="admin-users__body">
        <el-table
          :data="usersData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
          v-loading="loading"
        >
          <el-table-column type="index" width="50" align="center">
          </el-table-column>
          <el-table-column prop="workInfo.name" label="作品名称">
          </el-table-column>
          <el-table-column prop="regCertNum" label="登记编号">
          </el-table-column>
          <el-table-column prop="registerSource" label="登记来源">
          </el-table-column>
          <el-table-column prop="externalUserPhone" label="注册手机号">
          </el-table-column>
          <el-table-column
            prop="workInfo.workCategory.category"
            label="作品分类"
          >
          </el-table-column>
          <el-table-column prop="regSubject" label="登记主体">
          </el-table-column>
          <el-table-column prop="workPlace.place" label="工作站点">
          </el-table-column>
          <el-table-column label="申请状态">
            <template slot-scope="{ row }">
              <user-state-label
                :status="row.status"
              ></user-state-label>
            </template>
          </el-table-column>
          <el-table-column prop="auditUser" label="审核人"> </el-table-column>
          <el-table-column prop="createdDate" label="登记时间" width="180">
            <template slot-scope="{ row }">
              {{ moment(row.workInfo.createdDate).format("YYYY-MM-DD HH:mm") }}
            </template></el-table-column
          >
          <el-table-column label="证书" fixed="right" min-width="100">
            <template slot-scope="{ row }">
              <el-image
                v-if="row.workInfo.status === 'finished'"
                style="width: 53px; height: 70px"
                :preview-src-list="[row.digitalCopyrightFileUrl]"
                :src="row.digitalCopyrightFileUrl"
              ></el-image>
              <span v-else>暂无证书</span>
            </template>
          </el-table-column>
          <el-table-column prop="action" fixed="right" width="60" label="操作">
            <template slot-scope="{ row }">
              <el-button
                v-if="row.workInfo.status === 'waitAudit'"
                @click="toDetail(row, 'adt')"
                type="text"
                size="mini"
                >审核</el-button
              >
              <el-button
                v-else
                @click="toDetail(row, 'dtl')"
                type="text"
                size="mini"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
  </div>
</template>
<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import UserStateLabel from "./components/userStateLabel";
import {
  szbqdjPage,
  workPlaceUrl,
  getAllWorkCategory,
  getAllRegisterSource,
} from "@/api/req";
import { TYPE, TYPE_zh, STATUS, STATUS_zh } from "./_eum";

export default {
  name: "users",
  components: {
    PageTitle,
    CusPagination,
    UserStateLabel,
  },
  data() {
    return {
      filterStatus: "",
      filter: {},
      usersData: [],
      workPlaceList: [],
      registerSourceList: [],
      workCategoryList: [],
      currentPage: 1,
      value2: [],
      pageSize: 10,
      total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      loading: true,
    };
  },
  computed: {
    TYPE: () => TYPE,
    TYPE_zh: () => TYPE_zh,
    STATUS: () => STATUS,
    STATUS_zh: () => STATUS_zh,
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    toDetail(row, action) {
      sessionStorage.setItem("curData", JSON.stringify(row));
      this.$router.push({
        path: "/digitalRights/" + row.id + "/" + action,
        state: {
          ...row,
        },
      });
    },
    handleChange(v) {
      console.log(v);
      this.filter.status = v;
      this.getList();
    },
    handleFormatDate(value) {
      if (!value) {
        this.filter.startDate = "";
        this.filter.endDate = "";
      }
      this.filter.startDate = value[0];
      this.filter.endDate = value[1];
    },
    getWorkPlace() {
      this.$ajax.get(workPlaceUrl).then((res) => {
        this.workPlaceList = res.data;
      });
    },
    getAllWorkCategory() {
      this.$ajax.get(getAllWorkCategory).then((res) => {
        this.workCategoryList = res.data;
      });
    },
    getAllRegisterSource() {
      this.$ajax.get(getAllRegisterSource).then((res) => {
        this.registerSourceList = res.data.data.rows;
      });
    },
    getList() {
      this.loading = true;
      const req = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        status: this.filterStatus,
        ...this.filter,
      };
      this.$ajax
        .get(szbqdjPage, req)
        .then(({ data }) => {
          console.log("data", data);
          this.total = data.total;
          this.usersData = Object.freeze(data.rows);
          this.loading = false;
        })
        .catch((err) => {
          console.log("err.data :>> ", err.data);
          this.loading = false;
        });
    },
  },
  created() {
    const { query } = this.$route;
    if (JSON.stringify(query) !== "{}") {
      this.filter = Object.assign(this.filter, query);
    }
    if (query.status) {
      this.filterStatus = query.status;
    }
    this.getWorkPlace();
    this.getAllWorkCategory();
    this.getAllRegisterSource();
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio-button.is-active .el-radio-button__inner {
  background-color: #002b9c;
  border-color: #002b9c;
}
.el-button {
  color: #002b9c;
}
</style>
